import { useTranslations } from "adapters/i18n";
import React, { useMemo } from "react";
import type { FarmAndRetreatLink } from "../../../../userManagement.types";
import RemoveLinkButton from "../components/removeLinkButton";

type UseLinksTableColumnsProps = {
  onRemoveLink: (farmId: number) => void;
};

export function useLinksTableColumns({
  onRemoveLink,
}: UseLinksTableColumnsProps) {
  const { t } = useTranslations();

  const columns = useMemo(
    () => [
      {
        id: "farm",
        titulo: t("locales:farm").toUpperCase(),
        ordenavel: true,
        estilo: { width: "25%" },
        pegaValor: (row: FarmAndRetreatLink) => row.farm.name,
      },
      {
        id: "retreats",
        titulo: t("locales:retreats").toUpperCase(),
        ordenavel: false,
        estilo: { width: "70%" },
        pegaValor: (row: FarmAndRetreatLink) =>
          row.retreats.map((retreat) => retreat.name).join(", "),
      },
      {
        id: "remove",
        titulo: t("common:actions.remove").toUpperCase(),
        ordenavel: false,
        estilo: { width: "5%" },
        pegaValor: (row: FarmAndRetreatLink) => (
          <RemoveLinkButton
            key={row.farm.id}
            onClick={() => onRemoveLink(row.farm.id)}
          />
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  );

  return { columns };
}
